import clsx from 'clsx'
import React from 'react'
import useStyles from './CardsLayout.styles'

type CardsLayoutProps = {
  isDesktop?: boolean
  className?: string
  containerClassName?: string
  noPadding?: boolean
  noGap?: boolean
  children: React.ReactNode
}

const CardsLayout = ({
  isDesktop,
  children,
  className,
  noPadding = false,
  noGap = false,
  containerClassName,
}: CardsLayoutProps) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, { [classes.noPadding]: noPadding }, className)}>
      <div
        className={clsx(
          classes.container,
          { [classes.noGap]: noGap, [classes.desktop]: isDesktop },
          containerClassName
        )}
      >
        {children}
      </div>
    </div>
  )
}

export default CardsLayout
